import React, {Component} from 'react';
import RaportyService from "../../RaportyService";
import {HorizontalGridLines, LabelSeries, VerticalBarSeries as BarSeries, VerticalGridLines, XAxis, XYPlot, YAxis} from "react-vis/es/index";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";


export default class RozliczenieKursyPojazdyContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dane: [],
        };
    }

    componentDidMount() {
        this.pobierzDaneDoRaportu(this.props.daty)
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.daty)) {
            this.pobierzDaneDoRaportu(nextprops.daty)
        }
    }

    pobierzDaneDoRaportu(daty) {
        RaportyService.pobierzSzczegoloweRozliczenieKursowPojazdy(daty[0],daty[1]).then(function (response) {
            this.setState({dane:response.data})
        }.bind(this))
    }

    render() {

        return (
            <div>
                <div>
                    <XYPlot width={1600} height={300}  xType="ordinal" getX={d => d.nrRej} getY={d => d.sumDystans} margin={{top:10,bottom:100}}>
                        <VerticalGridLines/>
                        <HorizontalGridLines/>
                        <XAxis tickLabelAngle={-60}/>
                        <YAxis title={'Dystans [km]'}/>
                        <BarSeries data={this.state.dane} color={'#83c33a'}/>
                        <LabelSeries data={this.state.dane} getLabel={d => d.sumDystans} style={{fontSize:'10px'}} rotation={-5}/>
                    </XYPlot>
                </div>
                <div>
                    <BootstrapTable data={this.state.dane}
                                    hover
                    >
                        <TableHeaderColumn dataField='idPo' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='nrRej' dataSort
                                           thStyle={tabgrid.tg17} tdStyle={tabgrid.tg17}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Rejestracja</TableHeaderColumn>
                        <TableHeaderColumn dataField='sumDystans' dataSort
                                           thStyle={tabgrid.tg8} tdStyle={tabgrid.tg8}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Suma dystansu [km]</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/RozliczenieKursow/Pojazdy/RozliczenieKursyPojazdyContainer.js